define('viewmodels/pages/404',[],function () {

    return function NotFoundViewModel (getFields) {
        var self = this;

        self.image = getFields('404_image');
        self.notFoundText = getFields('404_description');
        self.notFoundBtnText = getFields('404_button');

        self.meta = {
            statusCode: 404
        };
    };
});

